import React, { useState } from 'react';

import { Button } from '@components/button';
import { TagSelectorSingle } from '@components/tag-selector/tag-selector';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useCurrentCompany } from 'api/authentication/hooks';
import { useEditCompanyDetails } from 'api/company/hooks';

import { PreboardingPage } from './common';

import { CompanyPreboardingStepper, useNextStep } from '../navigation';

const EMPLOYEE_COUNTS = [
  '1 - 20',
  '21 - 100',
  '101 - 500',
  '501 - 1.000',
  '1.001 - 5.000',
  '1.001 - 5000',
  '5.001 - 10.000',
  '10.001 - 20.000',
  '20.001+',
];

export const CompanyEmployeeCountPage = () => {
  const { t } = useScopedTranslate(locale);
  const [selected, setSelected] = useState('');
  const editMutation = useEditCompanyDetails({ shouldNotShowSuccess: true });
  const currentCompany = useCurrentCompany();

  const navigateToNextStep = useNextStep();

  const handleContinue = async () => {
    if (selected) {
      await editMutation.mutateAsync({ employeeCount: selected });
    }
    navigateToNextStep();
  };

  return (
    <PreboardingPage>
      <Text text={t('title', { companyName: currentCompany?.name ?? '' })} font="heading1" center />
      <TagSelectorSingle
        options={EMPLOYEE_COUNTS}
        onChange={setSelected}
        defaultValue={currentCompany?.employeeCount}
      />
      <Button
        variant="primary-blue"
        onClick={() => handleContinue()}
        isDisabled={!selected && !currentCompany?.employeeCount}
      >
        {t('core.continue')}
      </Button>
      <CompanyPreboardingStepper />
    </PreboardingPage>
  );
};

const locale = {
  en: {
    title: 'How large is {companyName}?',
    companyName: 'Company name',
  },
};
